import { FEATURE_SEGMENT_ANY, queryFeatureElements } from "./feature";
import {
	convertToNumber,
	getAttrDataClass,
	getAttrDataCutLocation,
	getAttrDataId,
	getElementsByClasses,
	getParentElement,
	getSvgParentElement,
	handleClicks,
	hideTooltip,
	hideTooltipByElement,
	showTooltipByElement,
} from "./common";

// const MAP_SEQ_INTERACTIVITY_CLIENT_VERSION = "2.1.2";

// const startup = function() {};

const showTooltip = (svgParentElement, tooltipId, boundingBoxId, showAbove) => {
	const tipElement = document.getElementById(tooltipId);
	if (tipElement == null) {
		return;
	}

	const over = document.getElementById(boundingBoxId);
	if (over == null) {
		return;
	}

	showTooltipByElement(svgParentElement, tipElement, [over], showAbove);
};

export const brandingOver = (event) => {
	const svgParentElement = getSvgParentElement(event);
	showTooltip(svgParentElement, "branding_tooltip", "branding_svg");
	const brandingSvgUnderline = document.getElementById(
		"branding_svg_underline",
	);
	if (brandingSvgUnderline) {
		brandingSvgUnderline.style.opacity = 1.0;
	}

	// set it as pointer and left it for the lifetime of the page
	const brandingSvg = document.getElementById("branding_svg");
	if (brandingSvg) {
		brandingSvg.style.cursor = "pointer";
	}
};

export const brandingOut = () => {
	hideTooltip("branding_tooltip");
	const brandingSvgUnderline = document.getElementById(
		"branding_svg_underline",
	);
	if (brandingSvgUnderline) {
		brandingSvgUnderline.style.opacity = 0.0;
	}
};

export const brandingUp = () => {
	const win = window.open("https://snapgene.com", "_blank");
	win.focus();
};

// shows, hides or toggles visibility for all elements of a specific class.
// Pass in the class name and either "visible", "hidden" or "toggle"
const setVisibility = (elements, command) => {
	for (let j = 0; j < elements.length; j += 1) {
		const element = elements[j];

		if (command === "visible") {
			element.style.visibility = "visible";
		} else if (command === "hidden") {
			element.style.visibility = "hidden";
		} else if (command === "toggle") {
			element.style.visibility =
				element.style.visibility === "hidden" ? "visible" : "hidden";
		}
	}
};

// select all DOM elements with the same class name, enzyme id and cut location
const queryEnzymeElements = (
	parentElement,
	classNames,
	enzymeId,
	cutLocation,
) => {
	const ENZYME_ID = convertToNumber(enzymeId);
	const CUT_LOCATION = convertToNumber(cutLocation);
	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	// filter by first class name
	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElement.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let skip = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				skip = true;
				break;
			}
		}

		if (!skip) {
			const id = getAttrDataId(e);
			const cut = getAttrDataCutLocation(e);
			if (id === ENZYME_ID && cut === CUT_LOCATION) {
				ret.push(e);
			}
		}
	}
	return ret;
};

// select all DOM elements with the same class name and enzyme id, but NOT
// the same cut location.
const querySimilarEnzymeElements = (
	parentElement,
	classNames,
	enzymeId,
	cutLocation,
) => {
	const ENZYME_ID = convertToNumber(enzymeId);
	const CUT_LOCATION = convertToNumber(cutLocation);

	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElement.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let skip = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				skip = true;
				break;
			}
		}

		if (!skip) {
			const id = getAttrDataId(e);
			const cut = getAttrDataCutLocation(e);
			if (id === ENZYME_ID && cut !== CUT_LOCATION) {
				ret.push(e);
			}
		}
	}
	return ret;
};

export const enzymeOver = (event, enzymeId, cutLocation) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// need to get the placement hint for the tooltip
	const sideHint = event.target
		.closest(".sg-hittest")
		.getAttribute("data-side");
	const showAbove = sideHint === "top";

	// show the enzyme over elements, plus recognition sequence and cut indicator.  Show similar elements for
	// other enzymes related to this id/cut location.

	// the recogintion and cut indicator class names have changed over time  they have been
	// sg-enzyme-recognition-sequence
	// or
	// sg-enzyme sg-recognition-sequence

	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-over",
			enzymeId,
			cutLocation,
		),
		"visible",
	);
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme-recognition-sequence",
			enzymeId,
			cutLocation,
		),
		"visible",
	);
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme-cut-indicator",
			enzymeId,
			cutLocation,
		),
		"visible",
	);
	setVisibility(
		querySimilarEnzymeElements(
			parentElement,
			"sg-enzyme sg-similar",
			enzymeId,
			cutLocation,
		),
		"visible",
	);
	showTooltipByElement(
		svgParentElement,
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-tooltip",
			enzymeId,
			cutLocation,
		)[0],
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-hittest",
			enzymeId,
			cutLocation,
		),
		showAbove,
		true,
	);
};

export const enzymeOut = (event, enzymeId, cutLocation) => {
	const parentElement = getParentElement(event);

	// hide everything related to this enzyme.
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-over",
			enzymeId,
			cutLocation,
		),
		"hidden",
	);
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme-recognition-sequence",
			enzymeId,
			cutLocation,
		),
		"hidden",
	);
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme-cut-indicator",
			enzymeId,
			cutLocation,
		),
		"hidden",
	);
	setVisibility(
		querySimilarEnzymeElements(
			parentElement,
			"sg-enzyme sg-similar",
			enzymeId,
			cutLocation,
		),
		"hidden",
	);
	hideTooltipByElement(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-tooltip",
			enzymeId,
			cutLocation,
		)[0],
	);
};

export const enzymeClick = (event, enzymeId, cutLocation) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	setVisibility(
		queryEnzymeElements(
			parentElement,
			"sg-enzyme sg-selected",
			enzymeId,
			cutLocation,
		),
		"toggle",
	);
};

// select all DOM elements with the same class name, primer id and cut location
const queryPrimerElements = (
	parentElement,
	classNames,
	primerId,
	cutLocation,
) => {
	const PRIMER_ID = convertToNumber(primerId);
	const CUT_LOCATION = convertToNumber(cutLocation);
	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElement.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let skip = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				skip = true;
				break;
			}
		}

		if (!skip) {
			const id = getAttrDataId(e);
			const cut = getAttrDataCutLocation(e);
			if (id === PRIMER_ID && cut === CUT_LOCATION) {
				ret.push(e);
			}
		}
	}
	return ret;
};

// select all DOM elements with the same class name and primer id, but NOT
// the same cut location.
const querySimilarPrimerElements = (
	parentElement,
	classNames,
	primerId,
	cutLocation,
) => {
	const PRIMER_ID = convertToNumber(primerId);
	const CUT_LOCATION = convertToNumber(cutLocation);

	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElement.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let skip = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				skip = true;
				break;
			}
		}

		if (!skip) {
			const id = getAttrDataId(e);
			const cut = getAttrDataCutLocation(e);
			if (id === PRIMER_ID && cut !== CUT_LOCATION) {
				ret.push(e);
			}
		}
	}
	return ret;
};

export const primerOver = (event, primerId, cutLocation) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// need to get the placement hint for the tooltip
	const sideHint = event.target
		.closest(".sg-hittest")
		.getAttribute("data-side");
	const showAbove = sideHint === "top";

	// show the primer over elements, plus recognition sequence and cut indicator.  Show similar elements for
	// other primers related to this id/cut location.
	setVisibility(
		queryPrimerElements(
			parentElement,
			"sg-primer sg-over",
			primerId,
			cutLocation,
		),
		"visible",
	);
	setVisibility(
		querySimilarPrimerElements(
			parentElement,
			"sg-primer sg-similar",
			primerId,
			cutLocation,
		),
		"visible",
	);
	showTooltipByElement(
		svgParentElement,
		queryPrimerElements(
			parentElement,
			"sg-primer sg-tooltip",
			primerId,
			cutLocation,
		)[0],
		queryPrimerElements(
			parentElement,
			"sg-primer sg-hittest",
			primerId,
			cutLocation,
		),
		showAbove,
	);
};

export const primerOut = (event, primerId, cutLocation) => {
	const parentElement = getParentElement(event);

	// hide everything related to this primer.
	setVisibility(
		queryPrimerElements(
			parentElement,
			"sg-primer sg-over",
			primerId,
			cutLocation,
		),
		"hidden",
	);
	setVisibility(
		querySimilarPrimerElements(
			parentElement,
			"sg-primer sg-similar",
			primerId,
			cutLocation,
		),
		"hidden",
	);
	hideTooltipByElement(
		queryPrimerElements(
			parentElement,
			"sg-primer sg-tooltip",
			primerId,
			cutLocation,
		)[0],
	);
};
export const primerClick = (event, primerId, cutLocation) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	setVisibility(
		queryPrimerElements(
			parentElement,
			"sg-primer sg-selected",
			primerId,
			cutLocation,
		),
		"toggle",
	);
};
export const featureOver = (event, featureId, segmentIndex, lineNumber) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// need to get the placement hint for the tooltip
	const sideHint = event.target
		.closest(".sg-hittest")
		.getAttribute("data-side");
	const showAbove = sideHint === "top";

	// show the feature over elements, plus recognition sequence and cut indicator.  Show similar elements for
	// other features related to this id/cut location.
	//
	// Note, we set the segment index to FEATURE_SEGMENT_ANY when searching for hittest regions because we want all the segments
	//   to be visible for the feature.
	setVisibility(
		queryFeatureElements(
			parentElement,
			"sg-feature sg-over",
			featureId,
			FEATURE_SEGMENT_ANY,
			-1,
		),
		"visible",
	);
	showTooltipByElement(
		svgParentElement,
		queryFeatureElements(
			parentElement,
			"sg-feature sg-tooltip",
			featureId,
			segmentIndex,
			-1,
		)[0],
		queryFeatureElements(
			parentElement,
			"sg-feature sg-hittest",
			featureId,
			FEATURE_SEGMENT_ANY,
			lineNumber,
		),
		showAbove,
	);
};

export const featureOut = (event, featureId, segmentIndex) => {
	const parentElement = getParentElement(event);

	// hide everything related to this feature.
	setVisibility(
		queryFeatureElements(
			parentElement,
			"sg-feature sg-over",
			featureId,
			FEATURE_SEGMENT_ANY,
			-1,
		),
		"hidden",
	);
	hideTooltipByElement(
		queryFeatureElements(
			parentElement,
			"sg-feature sg-tooltip",
			featureId,
			segmentIndex,
			-1,
		)[0],
	);
};

export const featureClick = (event, featureId) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	setVisibility(
		queryFeatureElements(
			parentElement,
			"sg-feature sg-selected",
			featureId,
			FEATURE_SEGMENT_ANY,
			-1,
		),
		"toggle",
	);
};
/*
const orf_over = (event, orfId) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// show the orf over elements and tooltips
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-over", orfId, -1), "visible");
	showTooltipByElement(
		svgParentElement,
		queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0],
		queryOrfElements(parentElement, "sg-orf sg-hittest", orfId, -1),
	);
};

const orfOut = (event, orfId) => {
	const parentElement = getParentElement(event);

	// hide everything related to this orf.
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-over", orfId, -1), "hidden");
	hideTooltipByElement(queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0]);
};

const orfClick = (event, orfId) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-selected", orfId, -1), "toggle");
};

const orfbOver = (event, orfId, centerBase, orfPosition, letterCode) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// find the text element
	const t = queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase)[0];
	t.style.fontWeight = "700";

	// show the orf over elements and tooltips
	const tooltip = queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0];

	let protien = "?";
	if (letterCode == "A") protien = "Alanine";
	if (letterCode == "B") protien = "Asparagine";
	if (letterCode == "C") protien = "Cysteine";
	if (letterCode == "D") protien = "Aspartic Acid";
	if (letterCode == "E") protien = "Glutamic Acid";

	if (letterCode == "F") protien = "Phenylalanine";
	if (letterCode == "G") protien = "Glycine";
	if (letterCode == "H") protien = "Histidine";
	if (letterCode == "I") protien = "Isoleucine";
	if (letterCode == "J") protien = "Leucine";

	if (letterCode == "K") protien = "Lysine";
	if (letterCode == "L") protien = "Leucine";
	if (letterCode == "M") protien = "Methionine";
	if (letterCode == "N") protien = "Asparagine";
	if (letterCode == "O") protien = "Pyrrolysine";

	if (letterCode == "P") protien = "Proline";
	if (letterCode == "Q") protien = "Glutamine";
	if (letterCode == "R") protien = "Arginine";
	if (letterCode == "S") protien = "Serine";
	if (letterCode == "T") protien = "Threonine";

	if (letterCode == "U") protien = "Selenocysteine";
	if (letterCode == "V") protien = "Valine";
	if (letterCode == "W") protien = "Tryptophan";
	if (letterCode == "X") protien = "Any";
	if (letterCode == "Y") protien = "Tyrosine";
	if (letterCode == "Z") protien = "Glutamine";

	// find the inner html, rip out everything before ORF and fill in with more parameters
	let s = tooltip.children[0].children[0].children[0].innerHTML;
	const pos = s.indexOf("ORF:");
	s = s.substr(pos);
	if (orfPosition == -1) {
		s = `Stop<br><br>${s}`;
	} else {
		s = `${protien} (${orfPosition})<br><br>${s}`;
	}
	tooltip.children[0].children[0].children[0].innerHTML = s;

	showTooltipByElement(
		svgParentElement,
		tooltip,
		queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase),
		false,
	);
};

const orfbOut = (event, orfId, centerBase) => {
	const parentElement = getParentElement(event);

	const tooltip = queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0];

	// hide everything related to this orf.
	hideTooltipByElement(tooltip);

	const t = queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase)[0];
	t.style.fontWeight = "400";
};

const orfbClick = (event, orfId, centerBase) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	//    setVisibility(query_orf_elements( "sg-orf sg-selected", orfId ), "toggle");
};
*/
